import { render, staticRenderFns } from "./ElementActionsTableColumn.vue?vue&type=template&id=cd012e5a"
import script from "./ElementActionsTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementActionsTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementActionsTableColumn.vue?vue&type=style&index=0&id=cd012e5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports